// extracted by mini-css-extract-plugin
module.exports = {"row":"FolderGroup_row__nU_It","name":"FolderGroup_name__1yZcY","spaceBeforeName":"FolderGroup_spaceBeforeName__2qOjb"};